const SvgCsvIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={41}
    fill="none"
    {...props}
  >
    <g clipPath="url(#csv-icon_svg__a)">
      <path
        fill="#F69133"
        fillRule="evenodd"
        d="M5.691.5a3.17 3.17 0 0 0-3.17 3.171v33.65a3.17 3.17 0 0 0 3.17 3.172h28.61c1.75 0 3.17-1.42 3.17-3.171V13.194L25.657.5z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M15.191 27.498a.5.5 0 0 1 .124.326c0 .237-.191.45-.44.45a.4.4 0 0 1-.314-.146c-.439-.529-1.182-.867-1.88-.867-1.643 0-2.891 1.26-2.891 3.05 0 1.778 1.249 3.05 2.891 3.05.71 0 1.407-.304 1.88-.856a.44.44 0 0 1 .315-.146c.26 0 .44.225.44.462a.48.48 0 0 1-.125.315c-.585.607-1.384 1.058-2.509 1.058-2.16 0-3.86-1.576-3.86-3.883s1.7-3.882 3.86-3.882c1.125 0 1.935.45 2.51 1.07m4.252 6.696c-1.114 0-1.992-.37-2.634-.934a.44.44 0 0 1-.146-.337c0-.226.169-.474.439-.474.09 0 .191.023.27.09a3.15 3.15 0 0 0 2.104.822c1.34 0 1.767-.72 1.767-1.295 0-1.935-4.445-.866-4.445-3.545 0-1.237 1.103-2.082 2.577-2.082.968 0 1.8.292 2.408.8.101.09.158.213.158.337 0 .225-.191.45-.44.45a.43.43 0 0 1-.27-.102c-.55-.45-1.237-.652-1.924-.652-.9 0-1.542.484-1.542 1.193 0 1.688 4.445.72 4.445 3.523 0 1.092-.742 2.206-2.767 2.206m10.62-7.033-2.598 6.459a.82.82 0 0 1-.743.506h-.023a.82.82 0 0 1-.754-.506l-2.589-6.46a.5.5 0 0 1-.033-.18c0-.224.201-.495.506-.495.191 0 .371.113.45.304l2.43 6.245 2.431-6.245a.48.48 0 0 1 .45-.304.502.502 0 0 1 .474.676"
      />
      <path
        fill="#F79133"
        fillRule="evenodd"
        d="M37.5 13.223v.625h-8s-3.944-.787-3.83-4.192c0 0 .13 3.567 3.753 3.567z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M25.686.504v9.1c0 1.035.69 3.62 3.815 3.62h8z"
        clipRule="evenodd"
        opacity={0.5}
      />
    </g>
    <defs>
      <clipPath id="csv-icon_svg__a">
        <path fill="#fff" d="M0 .5h40v40H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCsvIcon;
